import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/notifications/i18n/es.ts
var es_default = {
  "widgets.notifications.fusion-swap-view.status.pending": "Pendiente",
  "widgets.notifications.fusion-swap-view.status.filled": "Completo",
  "widgets.notifications.fusion-swap-view.status.false-predicate": "Lleno",
  "widgets.notifications.fusion-swap-view.status.not-enough-balance-or-allowance": "Lleno",
  "widgets.notifications.fusion-swap-view.status.partially-filled": "Lleno",
  "widgets.notifications.fusion-swap-view.status.wrong-permit": "Lleno",
  "widgets.notifications.fusion-swap-view.status.invalid-signature": "Lleno",
  "widgets.notifications.fusion-swap-view.status.expired": "Expirado",
  "widgets.notifications.fusion-swap-view.status.cancelled": "Cancelado",
  "widgets.notifications.fusion-swap-view.control.cancel": "Cancelar"
};
export {
  es_default as default
};
//# sourceMappingURL=es-H5L7GO7Q.js.map
